import { render, staticRenderFns } from "./Kefu.vue?vue&type=template&id=6a6f498e&"
import script from "./Kefu.vue?vue&type=script&lang=js&"
export * from "./Kefu.vue?vue&type=script&lang=js&"
import style0 from "./Kefu.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports